import type { EmsComponents, NormalizedNullableResponse } from '../../api/ems';
import { normalizePortalLocation } from './location';
import type { PortalLocation } from './location';

export type IncidentListItemWire = EmsComponents['schemas']['PortalIncidentListItem'];
type NormalizedIncidentListItem = NormalizedNullableResponse<IncidentListItemWire>;
export type IncidentListItem = Omit<NormalizedIncidentListItem, 'lastPosition'> & {
  lastPosition: PortalLocation | null;
};
export type IncidentListAgencyView = IncidentListItem['agencyViews'][number];

export function normalizeIncidentListItem(item: IncidentListItemWire): IncidentListItem {
  const wire = item as unknown as IncidentListItemWire & {
    lastPosition?: PortalLocation | null;
  };

  return {
    ...item,
    closedTimeUtc: item.closedTimeUtc ?? null,
    lastPosition: wire.lastPosition == null ? null : normalizePortalLocation(wire.lastPosition),
    involvedAgencies: item.involvedAgencies.map((agency) => ({
      ...agency,
      position: agency.position ?? null,
      requestedBy: agency.requestedBy ?? null,
    })),
    additionalIncidentData: {
      ...item.additionalIncidentData,
      incidentLabel: item.additionalIncidentData.incidentLabel ?? null,
      callSign: item.additionalIncidentData.callSign ?? null,
      ateMessage: item.additionalIncidentData.ateMessage ?? null,
    },
  };
}
